/* Offline French/English interface resources. */
window.RENAX_TRANSLATIONS = Object.freeze({
  "legacy": {
"Dupliquer le temps 1 sur tous les temps":"Copy beat 1 to all beats",
"Pistes":"Tracks",
"Copie locale automatique. Connectez-vous pour retrouver vos morceaux sur vos appareils.":"Automatic local backup. Sign in to access your songs on your devices.",
"Animation d’arrivée":"Intro animation", "Animation d’arrivée Métronome":"Metronome introduction", "Presets multipistes":"Multitrack presets", "Nouveau preset":"New preset", "Crée ton premier preset multipiste.":"Create your first multitrack preset.", "Modifications non enregistrées":"Unsaved changes", "Écouter cette piste seule":"Play this track solo",
    "Apparence":"Appearance", "Sombre":"Dark", "Clair":"Light", "Préférences":"Preferences",
    "Voix de comptage": "Counting voices",
    "Préparer les voix hors connexion": "Prepare voices for offline use",
    "Les voix se chargent à la première utilisation.": "Voices load on first use.",
    "Préparation des voix…": "Preparing voices…",
    "Voix chargées. Le statut hors connexion confirme leur conservation.": "Voices loaded. The offline status confirms whether they are stored.",
    "Préparation impossible. Réessayez lorsque la connexion est disponible.": "Preparation failed. Try again when a connection is available.",
    "Aide en cas de problème": "Troubleshooting",
    "Exporter le diagnostic": "Export diagnostics",
    "Hors connexion": "Offline",
    "Impossible de démarrer le son. Vérifiez la sortie audio et réessayez.": "Unable to start audio. Check your audio output and try again.",
    "Une erreur est survenue. Vos données locales sont conservées. Réessayez cette action.": "An error occurred. Your local data is retained. Try this action again.",
    "Une opération a échoué. Vos données locales sont conservées. Réessayez cette action.": "An operation failed. Your local data is retained. Try this action again.",
    "Application et voix téléchargées disponibles hors connexion.": "The app and downloaded voices are available offline.",
    "Application disponible hors connexion. Les sons déjà téléchargés restent disponibles.": "The app is available offline. Previously downloaded sounds remain available.",
    "Nouvelle version prête. Fermez les onglets du métronome puis rouvrez le site pour l’utiliser.": "An update is ready. Close the metronome tabs and reopen the site to use it.",
    "Cache hors connexion indisponible. Le site et la sauvegarde locale restent utilisables en ligne.": "Offline caching is unavailable. The site and local backup remain usable online.",
    "Ce navigateur ne permet pas l’ouverture hors connexion. La copie JSON reste disponible.": "This browser cannot open the app offline. JSON backup remains available.",
    "Préparation de l’ouverture hors connexion…": "Preparing offline access…",
    "Copie de secours enregistrée dans ce navigateur. Exportez aussi votre bibliothèque.": "An emergency copy is saved in this browser. Export your library as well.",
    "Copie de secours récupérée. Vos dernières modifications sont disponibles.": "Emergency backup recovered. Your latest changes are available.",
    "Le changement de compte n’a pas pu être terminé. Exportez la copie locale avant de réessayer.": "The account change could not be completed. Export the local copy before trying again.",
    "Synchronisation suspendue": "Sync paused",
    "Temps par mesure": "Beats per bar",
    "Unité du temps": "Beat unit",
    "Mesures avec clic": "Bars with clicks",
    "Mesures silencieuses": "Silent bars",
    "Subdiviser ce temps": "Subdivide this beat",
    "Ivoire": "Ivory",
    "Lire": "Play",
    "Arrêter": "Stop",
    "Nouvelle piste": "New track",
    "Utilisation": "Using Renax",
    "Le déclenchement MIDI sera disponible dans une prochaine version.": "MIDI triggering will be available in a future version.",
    "Sélectionne une mesure ou une piste pour modifier son rythme. Le crayon ouvre l’éditeur de partition ; la flèche annule la dernière modification.": "Select a bar or track to edit its rhythm. The pencil opens notation editing; the arrow undoes the last edit.",
    "Chronomètre": "Timer",
    "Réglages musicaux": "Musical controls",
    "Vue de travail": "Workspace view",
    "Blocs": "Blocks",
    "Hi-hat fermé naturel": "Natural closed hi-hat",
    "Tambourin naturel": "Natural tambourine",
    "Multipiste": "Multitrack",
    "Track": "Track",
    "Espaces de travail": "Workspaces",
    "Retour au métronome": "Back to metronome",
    "MÉTRO": "METRO",
    "Mixte": "Mixed",
    "⏱ Décompte": "⏱ Count-in",
    "NB.": "NO.",
    "Écouter uniquement ce bloc": "Play this section only",
    "Paramètres": "Settings",
    "⚙ Paramètres": "⚙ Settings",
    "Paramètres techniques": "Settings",
    "Langue": "Language",
    "Langue de l’interface": "Interface language",
    "Interface": "Interface",
    "Fermer": "Close",
    "Réglages": "Controls",
    "Visualisation": "Display",
    "Métronome": "Metronome",
    "Polyrythmie": "Polyrhythm",
    "Séquenceur": "Sequencer",
    "Morceaux": "Songs",
    "Entraînement": "Practice",
    "Tempo (noire)": "Tempo (quarter note)",
    "Banque de sons": "Sound bank",
    "Volume": "Volume",
    "Progressif": "Continuous",
    "Par paliers": "Steps",
    "Début": "Start",
    "Arrivée": "Target",
    "Temps": "Beats",
    "Écart": "Increment",
    "Courbe": "Curve",
    "minutes": "minutes",
    "secondes": "seconds",
    "Mesures": "Bars",
    "Mesure": "Bar",
    "NB. MESURES": "NUMBER OF BARS",
    "Mesures vides": "Silent bars",
    "Avec clic": "Click bars",
    "Silence": "Rest",
    "Éteint": "Off",
    "Clic 1": "Click 1",
    "Clic 2": "Click 2",
    "Clic 3": "Click 3",
    "Unité": "Note value",
    "Décompte": "Count-in",
    "Guide Vocal": "Voice cues",
    "Retour": "Back",
    "Lire le morceau": "Play song",
    "Lire uniquement ce morceau": "Play this song only",
    "Démarrer l’entraînement": "Start practice",
    "Démarrer l'entraînement": "Start practice",
    "Arrêter l'entraînement": "Stop practice",
    "Arrêter l’entraînement": "Stop practice",
    "Arrêter l’entraînement avant de lire le morceau": "Stop practice before playing a song",
    "Arrête la lecture avant de démarrer l’entraînement": "Stop playback before starting practice",
    "Entraînement terminé.": "Practice complete.",
    "Préparation…": "Preparing…",
    "Préparation audio...": "Loading audio...",
    "PRÉPARATION AUDIO...": "LOADING AUDIO...",
    "Titre du morceau": "Song title",
    "Nom du morceau": "Song name",
    "Nouveau morceau": "New song",
    "Nouvelle playlist": "New playlist",
    "Nom de la playlist": "Playlist name",
    "Play lists": "Playlists",
    "Playlist": "Playlist",
    "Sauvegarde": "Backup",
    "Libellé": "Label",
    "+ Ajouter une section": "+ Add section",
    "Ajouter une section": "Add section",
    "Renommer": "Rename",
    "Supprimer": "Delete",
    "Dupliquer": "Duplicate",
    "Copier": "Copy",
    "Déplacer": "Move",
    "Annuler": "Cancel",
    "Valider": "Apply",
    "Enregistrer": "Save",
    "Exporter": "Export",
    "Export": "Export",
    "Exports": "Exports",
    "Disponible": "Available",
    "Non actif": "Not available",
    "À définir": "Not set",
    "MIDI & déclenchement": "MIDI & triggering",
    "Déclenchement START": "Start trigger",
    "Note MIDI START": "Start MIDI note",
    "Canal MIDI": "MIDI channel",
    "Export MP3": "MP3 export",
    "Export MIDI": "MIDI export",
    "Principe de cette variante": "Interface layout",
    "Dans la playlist, Exporter permet de choisir MP3 ou MIDI.": "Choose MP3 or MIDI from Export in the playlist.",
    "Emplacement réservé à la future commande MIDI. Aucun comportement MIDI n'est ajouté dans index2 : le moteur actuel reste inchangé.": "MIDI triggering is reserved for a future update.",
    "Les commandes musicales restent dans l'espace de travail. Les options techniques et futures intégrations sont isolées ici pour réduire la charge visuelle.": "Musical controls are in the workspace. Technical options are grouped here.",
    "Sélectionne un bloc pour le régler dans le métronome.": "Select a section to edit it in the metronome.",
    "Sélectionne une note ou un silence": "Select a note or rest",
    "Éditer la partition": "Edit notation",
    "Partition rythmique, police Bravura": "Rhythm notation, Bravura font",
    "Vue métronome circulaire": "Circular metronome view",
    "Vue partition": "Notation view",
    "Vue de visualisation": "Display mode",
    "Mode de fonctionnement": "Mode",
    "Outils de partition": "Notation tools",
    "Durées : simples en haut, pointées en bas": "Note values: standard above, dotted below",
    "Lecture en cours : application au prochain passage de la mesure.": "Playing: changes apply the next time this bar is played.",
    "Allonger absorbe les éléments suivants du groupe. Raccourcir crée un silence.": "Lengthening replaces the following notes in the group. Shortening adds a rest.",
    "Impossible de charger la partition. Réessaie avec Partition.": "Unable to load notation. Try Notation again.",
    "Ronde": "Whole note",
    "Blanche": "Half note",
    "Noire": "Quarter note",
    "Croche": "Eighth note",
    "Double": "Sixteenth note",
    "Triple": "Thirty-second note",
    "Quadruple": "Sixty-fourth note",
    "Quintuple": "128th note",
    "Sextuple": "256th note",
    "Note": "Note",
    "Notes": "Notes",
    "Regroupement libre": "Custom grouping",
    "Regroupement": "Grouping",
    "Subdivision": "Subdivision",
    "Subdivisions": "Subdivisions",
    "Ligatures": "Beams",
    "Pointée": "Dotted",
    "Pulsation": "Beat",
    "Clic bois": "Wood click",
    "Claves acoustiques": "Acoustic claves",
    "Cowbell acoustique": "Acoustic cowbell",
    "Triangle étouffé": "Muted triangle",
    "Shaker acoustique": "Acoustic shaker",
    "Voix masculine EN": "Male voice EN",
    "Voix féminine EN": "Female voice EN",
    "Kit TR-808": "TR-808 kit",
    "Clic studio": "Studio click",
    "Métronome quartz": "Quartz metronome",
    "Tick sec": "Dry tick",
    "Bloc électronique": "Electronic block",
    "Montée linéaire": "Linear increase",
    "Descente linéaire": "Linear decrease",
    "Montée puis descente linéaire": "Linear increase then decrease",
    "Descente puis montée linéaire": "Linear decrease then increase",
    "Montée arrondie": "Curved increase",
    "Descente arrondie": "Curved decrease",
    "Montée puis descente arrondie": "Curved increase then decrease",
    "Descente puis montée arrondie": "Curved decrease then increase",
    "Montée exponentielle": "Exponential increase",
    "Descente exponentielle": "Exponential decrease",
    "Montée exponentielle inverse": "Inverse exponential increase",
    "Descente exponentielle inverse": "Inverse exponential decrease",
    "Courbe du tempo": "Tempo curve",
    "Courbes du tempo": "Tempo curves",
    "Choisir la courbe du tempo": "Choose tempo curve",
    "BPM de départ": "Starting BPM",
    "BPM d’arrivée": "Target BPM",
    "Arrivée en BPM": "Target BPM",
    "Durée totale en minutes": "Total duration in minutes",
    "Durée totale en secondes": "Total duration in seconds",
    "Unité du temps d’entraînement": "Practice duration unit",
    "Unité de durée du palier": "Step duration unit",
    "Retour à la playlist": "Back to playlist",
    "Retour aux playlists": "Back to playlists",
    "Retour aux morceaux": "Back to songs",
    "Ajouter un décompte": "Add count-in",
    "Actions du décompte": "Count-in actions",
    "Réinitialiser": "Reset all",
    "Annuler la dernière modification": "Undo last change",
    "Plein écran": "Full screen",
    "Quitter le plein écran": "Exit full screen",
    "Plein écran indisponible dans ce navigateur": "Full screen is unavailable in this browser",
    "Connexion et compte": "Sign in and account",
    "Diminuer le tempo de 1 BPM": "Decrease tempo by 1 BPM",
    "Augmenter le tempo de 1 BPM": "Increase tempo by 1 BPM",
    "Modifier le tempo dans Réglages": "Change tempo in Controls",
    "Choisir l’emplacement et exporter": "Choose location and export",
    "MIDI — notes et tempo": "MIDI — notes and tempo",
    "Création du MIDI…": "Creating MIDI…",
    "Export annulé.": "Export cancelled.",
    "Vérification du niveau du MP3…": "Checking MP3 level…",
    "Analyse audio déjà en cours.": "Audio analysis is already running.",
    "Réglages audio incorrects.": "Invalid audio settings.",
    "Le niveau du MP3 ne peut pas être validé. Aucun fichier écrit.": "Unable to verify the MP3 level. No file was written.",
    "Pour choisir le dossier de destination, ouvre cet export dans Chrome ou Edge sur ordinateur.": "To choose the destination folder, export from Chrome or Edge on desktop.",
    "Morceau trop long pour cet export MIDI.": "This song is too long for MIDI export.",
    "Compte": "Account",
    "Connexion": "Sign in",
    "Déconnexion": "Sign out",
    "Se connecter": "Sign in",
    "Se déconnecter": "Sign out",
    "Créer un compte": "Create account",
    "Adresse e-mail": "Email address",
    "Mot de passe": "Password",
    "Mot de passe oublié ?": "Forgot password?",
    "Mon profil": "My profile",
    "Profil": "Profile",
    "Sauvegarder": "Back up",
    "Restaurer": "Restore",
    "Importer": "Import",
    "Exporter la sauvegarde": "Export backup",
    "Importer une sauvegarde": "Import backup",
    "Sauvegarde locale": "Local backup",
    "Sauvegarde cloud": "Cloud backup",
    "Synchroniser": "Sync",
    "Connecté": "Signed in",
    "Non connecté": "Signed out",
    "Voix indisponibles. Les clics restent disponibles.": "Voices unavailable. Click sounds remain available.",
    "Langue du guide vocal incorrecte.": "Invalid voice cue language.",
    "Valeur personnalisée": "Custom value",
    "Playlist de destination": "Destination playlist",
    "Renommer le track": "Rename track",
    "Déplacer le track": "Move track",
    "Copier le track": "Copy track",
    "Volume du fichier": "File volume",
    "Renforcé": "Boosted",
    "Dynamique d’origine": "Original dynamics",
    "Sauvegardé dans ce navigateur": "Saved in this browser",
    "Données distantes incompatibles. Aucune bibliothèque remplacée.": "Incompatible cloud data. Your library has not been replaced.",
    "Conflit à résoudre": "Conflict to resolve",
    "Synchronisé": "Synced",
    "Firebase n’est pas configuré. Aucun morceau n’a été transmis.": "Cloud backup is not configured. No songs have been uploaded.",
    "Sauvegarde locale indisponible": "Local backup unavailable",
    "Profil restauré": "Profile restored",
    "Les 20 dernières révisions de chaque élément sont affichées. Aucune version distante n’est purgée automatiquement.": "The latest 20 revisions of each item are shown. Cloud versions are never removed automatically.",
    "Rester connecté": "Stay signed in",
    "Exporter la source locale préservée": "Export preserved local backup",
    "Aucune source trouvée.": "No backup found.",
    "Connexion en ligne indisponible : projet Firebase non configuré.": "Online sign-in unavailable: cloud backup is not configured.",
    "Mot de passe oublié": "Forgot password",
    "Si cette adresse dispose d’un compte, un message de réinitialisation lui sera envoyé.": "If an account exists for this address, a password reset email will be sent.",
    "Vérifier mon adresse": "Verify my email",
    "Réessayer la synchronisation": "Retry sync",
    "Lier Google à ce compte": "Link Google to this account",
    "Les deux versions sont conservées jusqu’à votre choix.": "Both versions are kept until you choose.",
    "Conflit local à résoudre": "Local conflict to resolve",
    "Un autre onglet a modifié cette bibliothèque. Exportez votre copie puis rechargez pour récupérer l’autre version.": "Another tab changed this library. Export your copy, then reload to retrieve the other version.",
    "Type d’entraînement": "Practice mode",
    "Type d'entraînement": "Practice mode",
    "Nom": "Name",
    "Description": "Description",
    "Démarrer": "Start",
    "Tambourin acoustique": "Acoustic tambourine",
    "Hi-hat acoustique": "Acoustic hi-hat",
    "Nouvelle mesure": "New bar",
    "Presets MultiMétro": "MultiMétro presets",
    "Enregistrer sous…": "Save as…",
    "Sauvegarde automatique": "Autosave",
    "Enregistrer un preset": "Save preset",
    "Supprimer le preset": "Delete preset",
    "Nom du preset": "Preset name",
    "Nom de la piste": "Track name",
    "Preset incompatible.": "Incompatible preset.",
    "Réactiver la piste": "Unmute track",
    "Couper la piste": "Mute track",
    "Déplier le bloc": "Expand track",
    "Réduire le bloc": "Collapse track",
    "Éditer la mesure": "Edit bar",
    "Fermer l’éditeur": "Close editor",
    "Son": "Sound",
    "Crée une mesure pour commencer.": "Create a bar to get started.",
    "Entraînement disponible dans Séquenceur": "Practice is available in Sequencer",
    "Accélération / ralentissement": "Acceleration / deceleration",
    "Départ": "Start",
    "Sommet": "Peak",
    "Minimum": "Minimum",
    "Sommet (BPM)": "Peak (BPM)",
    "Minimum (BPM)": "Minimum (BPM)",
    "Courbes du tempo du bloc": "Section tempo curves",
    "Les tempos doivent respecter le sens de la courbe choisie.": "The tempos must follow the direction of the selected curve.",
    "Courbe de tempo du bloc incorrecte.": "Invalid section tempo curve.",
    "Accélération progressive": "Progressive acceleration",
    "Arrivée (BPM)": "Target (BPM)",
    "Le tempo de départ doit rester inférieur au tempo d’arrivée.": "The starting tempo must stay below the target tempo.",
    "Le tempo d’arrivée doit être supérieur au tempo de départ.": "The target tempo must be greater than the starting tempo.",
    "Accélération du bloc incorrecte.": "Invalid block acceleration.",
    "Tempo trop lent pour cet export MIDI.": "Tempo is too slow for this MIDI export."
  },
  "messages": {
    "fr": {
      "workspace.metronome": "Métronome",
      "workspace.polyrhythm": "Polyrythmie",
      "workspace.training": "Entraînement",
      "workspace.sequence": "Séquenceur",
      "workspace.multi": "Multipiste",
      "workspace.tracks": "Track",
      "diagnostics.heading": "Aide en cas de problème",
      "diagnostics.export": "Exporter le diagnostic",
      "voices.heading": "Voix de comptage",
      "voices.prepareOffline": "Préparer les voix hors connexion",
      "latency.identify": "Identifier les sorties audio",
      "latency.identifyHelp": "Autorisation micro ponctuelle pour identifier les sorties. Aucun enregistrement. Arrêtez la lecture avant de continuer.",
      "latency.identify.ready": "Identification terminée. Exportez le diagnostic.",
      "latency.identify.failed": "Identification impossible ou autorisation refusée. Exportez le diagnostic.",
      "latency.identify.unsupported": "Identification des sorties indisponible dans ce navigateur.",
      "latency.identify.stopRequired": "Arrêtez la lecture avant de demander cette autorisation.",
      "latency.identify.pending": "Identification en cours…",
      "latency.bluetooth": "Casque Bluetooth",
      "latency.bluetoothHelp": "Ajoute 200 ms au visuel. Désactivez cette option sur haut-parleur ou casque filaire.",
      "cloud.confirmTitle": "Confirmer l’import",
      "cloud.cancel": "Annuler",
      "cloud.accept": "Importer",
      "cloud.importGuest": "Importer les {count} morceaux sans compte dans {email} ? Aucun morceau existant ne sera remplacé.",
      "cloud.importDuplicate": "« {name} » utilise un identifiant déjà présent avec une autre version. Importer comme copie séparée, sans remplacer l’autre version ?",
      "cloud.importCancelled": "Import annulé : aucune donnée modifiée.",
      "cloud.importChanged": "Import annulé : le compte ou la bibliothèque a changé. Relancez l’import.",
      "latency.heading": "Synchronisation visuelle",
      "latency.manual": "Compensation manuelle (ms)",
      "latency.help": "Le décalage automatique de la sortie audio est ajouté à cette valeur.",
      "latency.calibrate": "Calibrer",
      "latency.tap": "Taper en rythme",
      "latency.apply": "Appliquer",
      "latency.cancel": "Annuler",
      "latency.instructions": "Tapez au moins 5 fois avec le clic, puis appliquez la médiane.",
      "latency.samples": "{count} frappes enregistrées",
      "latency.saved": "Calibration enregistrée.",
      "latency.saveError": "Valeur invalide ou enregistrement local impossible.",
      "latency.audioError": "Son indisponible pour la calibration."
    },
    "en": {
      "workspace.metronome": "Metronome",
      "workspace.polyrhythm": "Polyrhythm",
      "workspace.training": "Practice",
      "workspace.sequence": "Sequencer",
      "workspace.multi": "Multitrack",
      "workspace.tracks": "Track",
      "diagnostics.heading": "Troubleshooting",
      "diagnostics.export": "Export diagnostics",
      "voices.heading": "Counting voices",
      "voices.prepareOffline": "Prepare voices for offline use",
      "latency.identify": "Identify audio outputs",
      "latency.identifyHelp": "One-time microphone access to identify outputs. No recording. Stop playback before continuing.",
      "latency.identify.ready": "Identification complete. Export diagnostics.",
      "latency.identify.failed": "Identification unavailable or permission denied. Export diagnostics.",
      "latency.identify.unsupported": "Output identification unavailable in this browser.",
      "latency.identify.stopRequired": "Stop playback before requesting this permission.",
      "latency.identify.pending": "Identifying outputs…",
      "latency.bluetooth": "Bluetooth headphones",
      "latency.bluetoothHelp": "Adds 200 ms to the visuals. Disable this option for speakers or wired headphones.",
      "cloud.confirmTitle": "Confirm import",
      "cloud.cancel": "Cancel",
      "cloud.accept": "Import",
      "cloud.importGuest": "Import {count} guest songs into {email}? No existing songs will be replaced.",
      "cloud.importDuplicate": "“{name}” has an identifier already used by another version. Import as a separate copy without replacing that version?",
      "cloud.importCancelled": "Import cancelled: no data changed.",
      "cloud.importChanged": "Import cancelled: the account or library changed. Start the import again.",
      "latency.heading": "Visual synchronization",
      "latency.manual": "Manual offset (ms)",
      "latency.help": "The automatic audio output delay is added to this value.",
      "latency.calibrate": "Calibrate",
      "latency.tap": "Tap in time",
      "latency.apply": "Apply",
      "latency.cancel": "Cancel",
      "latency.instructions": "Tap at least 5 times with the click, then apply the median.",
      "latency.samples": "{count} taps recorded",
      "latency.saved": "Calibration saved.",
      "latency.saveError": "Invalid value or local saving unavailable.",
      "latency.audioError": "Audio unavailable for calibration."
    }
  }
});
